module.exports = __webpack_public_path__ + "img/xls.83bc924d.png";